import type { LucideIcon } from "lucide-react";

type CcServiceDemoCardHeaderProps = {
  title: string;
  titleId?: string;
  description?: string;
  badge?: string;
  icon?: LucideIcon;
};

/** Gray top band shared by growth feature cards and SEO/automation workflow cards. */
export function CcServiceDemoCardHeader({
  title,
  titleId,
  description,
  badge,
  icon: Icon,
}: CcServiceDemoCardHeaderProps) {
  return (
    <div
      className={[
        "cc-service-demo-card-bar",
        description ? "cc-service-demo-card-bar--with-desc" : null,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="cc-service-demo-card-bar__row">
        <h3 id={titleId} className="cc-service-demo-card-bar__title">
          {Icon ? (
            <Icon
              className="cc-service-demo-card-bar__icon"
              size={16}
              strokeWidth={1.5}
              aria-hidden="true"
            />
          ) : null}
          {title}
        </h3>
        {badge ? <span className="cc-service-demo-card-bar__badge">{badge}</span> : null}
      </div>
      {description ? (
        <p className="cc-service-demo-card-bar__desc">{description}</p>
      ) : null}
    </div>
  );
}
